"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M19 0H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 18H2V2h16v16z"];
//# sourceMappingURL=square.js.map